import { render, staticRenderFns } from "./WxAuth.vue?vue&type=template&id=448dcf90&scoped=true"
import script from "./WxAuth.vue?vue&type=script&lang=js"
export * from "./WxAuth.vue?vue&type=script&lang=js"
import style0 from "./WxAuth.vue?vue&type=style&index=0&id=448dcf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448dcf90",
  null
  
)

export default component.exports